// extracted by mini-css-extract-plugin
module.exports = {"hide":"Loader_hide__2RM6E","small":"Loader_small__310t7","medium":"Loader_medium__1IqAP","large":"Loader_large__3CAEZ"};